import React, {useCallback} from 'react';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import classNames from 'classname';
import {InfoMessage} from './../Messages/index';
const moment = extendMoment(Moment);

const HourSlots = ({
  step,
  dateRange,
  activeDay,
  onChange,
  selectedSlots=[],
  multiselect=true,
  customTimeSlots=null,
  readOnly,
  setActiveDate
}) => {
  const getSlots = () => {
    if (Array.isArray(customTimeSlots)) {
        return customTimeSlots = getSortedTimeSlot(customTimeSlots);
    }
    const range = moment.range(`2018-01-01 ${dateRange[0]}`, `2018-01-01 ${dateRange[1]}`);
    return [...range.by('minutes', {step})]
      .map(m => m.format('HH:mm A'));
  }
    const formatTimeSlot = (time) => {
        return moment('2018-01-01 ' + time.replace(" AM", "").replace(" PM", "")).format("hh:mm A")
    }

    const getSortedTimeSlot = (array) => {
        array = array.sort(function (a, b) {
            let a1 = moment(activeDay + " " + a, 'MM/DD/YYYY HH:mm A')._d;
            let b1 = moment(activeDay + " " + b, 'MM/DD/YYYY HH:mm A')._d;
            return a1 < b1 ? -1 : a1 > b1 ? 1 : 0;
        });
        return array;
    }

    const handleChange = useCallback((slot) => () => {
        setActiveDate(activeDay);
    if (!multiselect) {
      onChange({slots: [slot], activeDay, isMulti: multiselect});
      return;
    }

    const slots = selectedSlots.includes(slot)
      ? selectedSlots.filter(el => el !== slot)
      : [...selectedSlots, slot];
    onChange({slots, activeDay, isMulti: multiselect});
  }, [onChange, selectedSlots, activeDay, multiselect]);

  const getEmptyMessage = () => {
    return !activeDay && (
      <InfoMessage title='Select available date and then select time slot(s).' />
    );
  }

  return (
    <div>
      <div className='hour-slot-header'>
        <h4 className='page-subtitle'>Time Slots - {!activeDay ? 'No Date Selected' : activeDay}</h4>
        {!readOnly && activeDay && !selectedSlots.length && <InfoMessage title='Select time slot(s).' />}
      </div>
      <div className='slot-list'>
        {!getEmptyMessage() ? (
          <>
            {getSlots().map(el => {
              const disabled =
                moment(new Date(), 'MM/DD/YYYY HH:mm A').isAfter(moment(`${activeDay} ${el}`, 'MM/DD/YYYY HH:mm A'), 'minute')
              const className = classNames({
                'slot-list__item': true,
                'slot-list__item--active': selectedSlots.includes(el),
                'slot-list__item--disabled': disabled,
              });
              return (
                <div
                  key={el}
                  onClick={disabled ? () => null : handleChange(el)}
                  className={className}
                >
                      {formatTimeSlot(el)}
                </div>
              );
            })}
          </>
        ) : (
          <div className='slot-list__empty'>{getEmptyMessage()}</div>
        )}
      </div>
    </div>
  );
}

export default HourSlots;